import { path } from "./hooks/types";
import List from "./List";
import Update from "./Update";

export const Logs = {
  List: List,
  Update: Update,
  path: path,
  Permissions: {
    read: "read:Log",
    list: "list:Log",
  },
};
